export function patientCaveText(
  patient: { cave?: string | null } | null | undefined,
): string {
  const value = patient?.cave;
  return typeof value === 'string' ? value.trim() : '';
}
